import React from "react"
import { Link } from "react-router-dom"
import propTypes from "prop-types"

const Edit = ({ children, href, onClick }) => {
  return (
    <Link to={href} onClick={onClick} className="info-card_edit">
      {children}
    </Link>
  )
}

Edit.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  href: propTypes.string.isRequired,
  onClick: propTypes.func
}

Edit.defaultProps = {
  onClick: () => {}
}

export default Edit
